import { useTheme } from '@24i/nxg-sdk-higgs';
import { getTrackLabel, useEventListener } from '@24i/player-utils-react';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Options } from './components/Options';
import { Setting } from './components/Setting';
import { Container } from './styled';
export var SettingName;
(function (SettingName) {
    SettingName["audio"] = "Audio";
    SettingName["subtitles"] = "Subtitles";
    SettingName["quality"] = "Quality";
    SettingName["none"] = "None";
})(SettingName || (SettingName = {}));
export const SettingsModal = ({ playerInstance, className = '', styles = {
    container: null,
    settings: {
        container: null,
        title: {
            color: 'red',
        },
        currentContainer: null,
        currentTitle: {
            color: 'red',
        },
    },
    options: {},
}, disableVideoQualitySelector, }) => {
    const { theme } = useTheme();
    const { t } = useTranslation(['sott']);
    const [currentSetting, setCurrentSetting] = useState(SettingName.none);
    const [audioTracks, setAudioTracks] = useState(() => (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.audioTracks) || []);
    const [textTracks, setTextTracks] = useState(() => (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.textTracks) || []);
    const [videoTracks, setVideoTracks] = useState(() => (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.videoTracks) || []);
    const audioTrack = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.selectedAudioTrack;
    const textTrack = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.selectedTextTrack;
    const videoTrack = playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.selectedVideoTrack;
    const onMetadataLoaded = useCallback(() => {
        setAudioTracks(playerInstance.audioTracks);
        setTextTracks(playerInstance.textTracks);
        setVideoTracks(playerInstance.videoTracks);
    }, [playerInstance]);
    const onAudioTrackSelected = useCallback((selectedAudioTrack) => {
        const player = playerInstance;
        if (!player)
            return;
        player.audioTrack = selectedAudioTrack;
    }, [playerInstance]);
    const onTextTrackSelected = useCallback((selectedTextTrack) => {
        const player = playerInstance;
        if (!player)
            return;
        player.textTrack = selectedTextTrack;
    }, [playerInstance]);
    const onVideoTrackSelected = useCallback((selectedVideoTrack) => {
        const player = playerInstance;
        if (!player)
            return;
        player.videoTrack = selectedVideoTrack;
    }, [playerInstance]);
    const memoAudioLocalizedString = useMemo(() => t('player.audio'), []);
    const memoSubsLocalizedString = useMemo(() => t('player.subtitles'), []);
    const memoQualityLocalizedString = useMemo(() => t('player.videoQuality'), []);
    const onAudioChange = () => {
        setCurrentSetting(SettingName.audio);
    };
    const onSubsChange = () => {
        setCurrentSetting(SettingName.subtitles);
    };
    const onQualityChange = () => {
        setCurrentSetting(SettingName.quality);
    };
    let currentOptions = null;
    switch (currentSetting) {
        case SettingName.audio:
            currentOptions = {
                name: memoAudioLocalizedString,
                options: audioTracks,
                selected: audioTrack,
                onSelect: onAudioTrackSelected,
            };
            break;
        case SettingName.subtitles:
            currentOptions = {
                name: memoSubsLocalizedString,
                options: textTracks,
                selected: textTrack,
                onSelect: onTextTrackSelected,
            };
            break;
        case SettingName.quality:
            currentOptions = {
                name: memoQualityLocalizedString,
                options: videoTracks,
                selected: videoTrack,
                onSelect: onVideoTrackSelected,
            };
            break;
        default:
            currentOptions = null;
            break;
    }
    useEventListener('loadedmetadata', onMetadataLoaded, playerInstance);
    useEventListener('texttrackchanged', onMetadataLoaded, playerInstance);
    useEventListener('audiotrackchanged', onMetadataLoaded, playerInstance);
    useEventListener('videotrackchanged', onMetadataLoaded, playerInstance);
    return (React.createElement(Container, { theme: theme, style: styles.container, "data-test": "SettingModal", className: `SettingsModal ${className}` },
        currentSetting === SettingName.none && (React.createElement("div", { className: "SettingModal-Settings", style: styles.settingsContainer },
            Boolean(audioTracks && audioTracks.length) && (React.createElement(Setting, { styles: styles.settings, "data-test": `SettingModal-Setting-${SettingName.audio}`, className: "SettingModal-Setting Audio", name: memoAudioLocalizedString, currentValue: getTrackLabel(audioTrack, audioTracks), onClick: onAudioChange })),
            Boolean(textTracks && textTracks.length) && (React.createElement(Setting, { styles: styles.settings, "data-test": `SettingModal-Setting-${SettingName.subtitles}`, className: "SettingModal-Setting Text", name: memoSubsLocalizedString, currentValue: getTrackLabel(textTrack, textTracks), onClick: onSubsChange })),
            !disableVideoQualitySelector && Boolean(videoTracks && videoTracks.length) && (React.createElement(Setting, { styles: styles.settings, "data-test": `SettingModal-Setting-${SettingName.quality}`, className: "SettingModal-Setting Video", name: memoQualityLocalizedString, currentValue: videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.label, onClick: onQualityChange })))),
        currentSetting !== SettingName.none && currentOptions && (React.createElement(Options, Object.assign({ styles: styles.options, "data-test": "SettingModal-Options" }, currentOptions, { onBack: () => {
                setCurrentSetting(SettingName.none);
            } })))));
};
//# sourceMappingURL=index.js.map